export const productQueryKeys = {
  all: ["product"] as const,
  list: () => [...productQueryKeys.all, "list"] as const,
  detail: (productId: string) =>
    [...productQueryKeys.all, "detail", productId] as const,
};
